module.exports = __webpack_public_path__ + "img/1@2x (3).0ba494f7.png";